import React from 'react';
import classnames from 'classnames';
import { isValidPercentage, formatPercentageInner } from '../../utils';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IDevBudgetChangePercentageProps extends IBaseProps {
  value?: number | string | null;
  // 保留小数位数
  fractionDigits?: number;
  // 最大百分数限制（不区分正负）(比如999代表最大展示+999%，或者最小展示-999%)
  limit?: number;
}

const DevBudgetChangePercentage: React.FC<IDevBudgetChangePercentageProps> = (props) => {
  const { style, className, value, fractionDigits, limit, placeholder = '-' } = props;

  const { isValid: isValidPercentageNum, value: valueNum } = isValidPercentage(value);
  const isInvalidPercentageNum = !isValidPercentageNum;

  const valueFormatted = isInvalidPercentageNum ? '' : formatPercentageInner(valueNum, { fractionDigits, limit });
  // eslint-disable-next-line no-nested-ternary, prettier/prettier
  const valueClassName = isInvalidPercentageNum ? '' : (valueNum > 0 ? 'up' : 'down');

  return (
    <div
      style={style}
      className={classnames('dbg-block-percentage', className, valueClassName, { valid: isValidPercentageNum })}
    >
      {isInvalidPercentageNum && <span>{placeholder}</span>}
      {isValidPercentageNum && <span>{valueFormatted}</span>}
    </div>
  );
};

export default DevBudgetChangePercentage;
